// src/components/Studio/FilterChips.tsx
interface FilterChipsProps {
  label: string;
  options: Array<{ value: string; label: string; count?: number }>;
  value: string;
  onChange: (value: string) => void;
}

/**
 * Single-select filter row. Uses a real radiogroup so arrow keys and screen readers
 * behave, rather than a row of unlabelled buttons.
 */
const FilterChips = ({ label, options, value, onChange }: FilterChipsProps) => (
  <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
    {options.map((option) => {
      const selected = option.value === value;
      return (
        <button
          key={option.value || 'all'}
          type="button"
          role="radio"
          aria-checked={selected}
          onClick={() => onChange(option.value)}
          className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400 ${
            selected
              ? 'border-orange-500/50 bg-orange-500/15 text-orange-200'
              : 'border-white/10 text-neutral-400 hover:border-white/25 hover:text-neutral-200'
          }`}
        >
          {option.label}
          {typeof option.count === 'number' && (
            <span className="ml-1.5 text-xs text-neutral-500">{option.count}</span>
          )}
        </button>
      );
    })}
  </div>
);

export default FilterChips;
